import { useState } from "react";
import { ReactComponent as AddAnalysis } from "assets/indexMappingAdd.svg";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ModalCreateAnalysisTable } from "pages/gdt/modals/ModalCreateColumn/ModalCreateAnalysisTable";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

export const QuickActionInsertNewAnalysisTable = () => {
  const [showModal, setShowModal] = useState(false);
  const selectedTableId = useDataTableContext((s) => s.selectedTableId);
  const selectedTableFolder = useDataTableContext((s) => {
    const { selectedTableId, tables } = s;
    return tables.find((table) => table.id === selectedTableId)?.folder;
  });

  const handleClick = () => {
    setShowModal(true);
  };

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <ButtonIconPermissioned
        requiredPermission="edit"
        defaultTooltip="Insert new analysis"
        aria-label="Insert new analysis"
        size="xs"
        iconType={AddAnalysis}
        onClick={() => void handleClick()}
        id={"quickActionInsertNewAnalysis"}
      />
      {showModal && (
        <ModalCreateAnalysisTable
          dataTableId={selectedTableId}
          folderId={selectedTableFolder}
          onClose={onClose}
        />
      )}
    </>
  );
};
